import { render, staticRenderFns } from "./CollectionListing.vue?vue&type=template&id=481670aa"
import script from "./CollectionListing.vue?vue&type=script&lang=js"
export * from "./CollectionListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports